export const activeLanguageKey = 'activeLanguageName';
